import { Button, Icon, SegmentedButton, Typography } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { TagWorksInfoModal } from '@hero/components/modals';
import { PageLayout } from '@hero/layouts';
import { TagTable } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useCreateTag, useGetTagList } from '@hero/services/contact-service/hooks';
import { useNotification } from '@hero/store/hooks';
import { formatNumber, getNameFeatureFormData } from '@hero/utils';
import { getNameRule } from '@hero/validations';

import * as S from '../style';

export default function ContactTagsPage() {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const { data: tagList } = useGetTagList();
  const { mutateAsync: createTag } = useCreateTag();

  const [isOpen, setIsOpen] = useState(false);

  const tabOptions = [
    {
      label: t('contacts'),
      value: ROUTE_PATHS.CONTACTS
    },
    {
      label: t('tags'),
      value: ROUTE_PATHS.CONTACT_TAGS
    }
  ];

  return (
    <PageLayout
      header={{
        title: t('contactManagement'),
        createButton: {
          onClick: () => {
            showNotification({
              header: t('nameYourTag'),
              formData: getNameFeatureFormData({
                label: t('featureName', { featureType: t('tag') })
              }),
              primaryButtonProps: {
                children: t('next'),
                endIcon: 'next'
              },
              onSubmit: async ({ formValues, validate }) => {
                const isValid = await validate([
                  {
                    rule: getNameRule(t('tag')),
                    value: formValues.name
                  }
                ]);
                if (!isValid) return true;

                await createTag(formValues);
              },
              secondaryButtonProps: {
                children: t('cancel')
              },
              notificationImage: <Icon name="tag" size="xxl" />
            });
          },
          children: t('addTags')
        }
      }}
    >
      <S.Wrapper>
        <SegmentedButton
          size="sm"
          options={tabOptions}
          activeTab={ROUTE_PATHS.CONTACT_TAGS}
          onChange={tab => {
            navigate(tab);
          }}
          withLine
          updateHash={false}
        />
        <S.SectionHeader>
          <Typography variant="body2">
            <Trans
              i18nKey="totalTags"
              values={{ count: formatNumber(tagList?.pagination?.total) || 0 }}
              components={{ b: <b /> }}
            />
          </Typography>
          <Button
            variant="link"
            onClick={() => {
              setIsOpen(true);
            }}
            color="neutral"
            startIcon={<Icon name="info" />}
          >
            {t('whatIsATag')}
          </Button>
        </S.SectionHeader>
        <TagTable disabledColumns={['birthday', 'anniversary']} />
      </S.Wrapper>
      <TagWorksInfoModal isOpen={isOpen} onOpen={setIsOpen} />
    </PageLayout>
  );
}
